<template>
    <div v-if="isLoaded">
        <div class="content-body">
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModal"
                     @ok="handleOk">
                <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                  <label>Código</label>
                  <b-form-input type="text"
                                placeholder="Código"
                                v-model="form.cd"
                                name="cd"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

                  <label>Código ERP</label>
                  <b-form-input type="text"
                                placeholder="Código ERP"
                                v-model="form.cd_erp"
                                name="cd_erp"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('cd_erp')" v-if="form.errors.has('cd_erp')"></b-form-feedback>

                    <label>Nome</label>
                    <b-form-input type="text"
                                  placeholder="Nome"
                                  v-model="form.nome"
                                  name="nome"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

                    <label>Município</label>
                    <multiselect v-model="municipioSelected"
                        :options="optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_id')" v-if="form.errors.has('municipio_id')"></b-form-feedback>

                    <label>Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        stacked
                        plain
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>
                </form>
                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                       <div class="float-right">
                           <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                           <b-btn @click="showModal=false" variant="secondary">
                             Fechar
                           </b-btn>
                           <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                             Enviar
                           </b-btn>
                       </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        statusSelected: [],
        municipioSelected: [],
        optionsLivStatus: [],
        optionsMunicipio: [],
        activateDesativate: [],
        errors_array: [],
        helpForm: new Form({statusRecord: [], params: []}),
        form: new Form({
                  cd: '',
                  nome: '',
                  cd_erp: '',
                  porto_id: '',
                  status: '',
                  municipio_id: ''
              }),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    municipioSelected(obj) {
        this.form.municipio_id = obj.value;
    }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.porto_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.$parent.optionsLivStatus.forEach((obj)=>
      {
          this.optionsLivStatus.push({ text: obj.text, value: obj.value})
      })
      this.$parent.optionsMunicipio.forEach((obj)=>
      {
          this.optionsMunicipio.push({ label: obj.label, value: obj.value})
      })
      this.form.status = 1;
      this.municipioSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.$parent.optionsLivStatus.forEach((obj)=>
      {
          this.optionsLivStatus.push({ text: obj.text, value: obj.value})
      })
      this.$parent.optionsMunicipio.forEach((obj)=>
      {
          this.optionsMunicipio.push({ label: obj.label, value: obj.value})
      })
      this.form.cd = data.cd;
      this.form.nome = data.nome;
      this.form.cd_erp = data.cd_erp;
      if (data.municipio != null) {
          this.municipioSelected = {label: data.municipio.nome, value: data.municipio.municipio_id};
      }
      this.form.status = data.status.valor;
      this.form.porto_id = id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
